import { Construction, Merge } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

const data = [
  { text: "pages.recipes.craft-list.title", link: "/recipes/craft", icon: <Construction /> },
  { text: "pages.recipes.merge-list.title", link: "/recipes/merge", icon: <Merge /> },
];

export const RecipesSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.recipes" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </StyledPaper>
  );
};
